<template>
  <span>{{ displayValue }}</span>
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import MxEditorField from '@/mixins/editor-field'
@Component({
  components: {
  },
})
export default class extends Mixins(MxEditorField) {
  get displayValue() {
    return this.getValueText(this.value)
  }
}
</script>
<style scoped>
</style>
